module.exports = __webpack_public_path__ + "static/media/S-task16_nodeLink.8290467a.png";